import { formatPhone } from '@shared/utils/formatPhone';
import cx from 'classnames';
import type { ReactNode } from 'react';
import typography from '~styles/typography.scss';
import styles from './GuestInfo.scss';

interface GuestInfoProps {
  name: ReactNode;
  phone?: string;
  email?: string;
  className?: string;
}

export const GuestInfo = ({
  name,
  phone,
  email,
  className,
}: GuestInfoProps) => (
  <section className={cx(styles.container, className)} aria-label="Guest info">
    <h2 className={typography.h3}>{name}</h2>
    <span className={cx(typography.t1, styles.guestInfo)}>
      {phone ? formatPhone(phone) : 'None'}
    </span>
    {email && (
      <span className={cx(typography.t1, styles.guestInfo)} data-testid="email">
        {email}
      </span>
    )}
  </section>
);
